<template>
	<picture :ref="lazyImageLabel" class="picture-element">
		<source type="image/avif" v-bind="{ [isVisible ? 'srcset' : 'data-srcset']: iconUrl('avif') }" />
		<source type="image/webp" v-bind="{ [isVisible ? 'srcset' : 'data-srcset']: iconUrl('webp') }" />

		<img
			class="provider-icon"
			:class="[size]"
			:src="iconUrl('jpeg')"
			:loading="loading"
			:fetchpriority="loading === 'lazy' ? 'low' : 'auto'"
			width="50"
			height="50"
			:alt="provider.clearName"
			:title="provider.clearName"
			@click="$emit('click')"
		/>
	</picture>
</template>

<script setup lang="ts">
import { lazyImageLabel, useLazyImage } from '@/features/ui/composables/useLazyImage';

const props = withDefaults(
	defineProps<{
		provider?: {
			icon: string;
			clearName: string;
		};
		loading?: 'lazy' | 'eager';
		size?: 'icon' | 'small';
	}>(),
	{
		provider: () => ({
			icon: 'https://static.justwatch.com/static/compile_jw/assets/jw-icon-badge.png',
			clearName: 'JustWatch',
		}),
		loading: 'lazy',
		size: 'icon',
	}
);

const { jwConfig } = useRuntimeConfig().public;

const { _el, isVisible } = useLazyImage(props.loading !== 'eager');

function iconUrl(format: 'avif' | 'webp' | 'jpeg') {
	const prefix = props.provider.icon.startsWith('/') ? jwConfig.IMAGESCALER_URL : '';
	return (
		prefix +
		props.provider.icon.replace('{profile}', props.size === 'icon' ? 's100' : 's40').replace('{format}', format)
	);
}
</script>

<style scoped lang="scss">
.picture-element {
	display: inline-block;

	.provider-icon {
		width: 50px;
		height: 50px;
		min-width: 50px;
		border-radius: 20%;
		aspect-ratio: 1;

		&.small {
			width: 24px;
			height: 24px;
			min-width: 24px;
			border-radius: 4px;
		}
	}
}
</style>
